"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BoxedTable = ({
  columns,
  breakpoint,
  children,
  type = 'default',
  hasCheckbox = false,
  onDrop
}) => {
  const theme = (0, _react2.useTheme)();
  const defaultProps = {
    hasCheckbox: hasCheckbox,
    columns: columns,
    bp: breakpoint,
    type: type,
    theme: theme
  };
  const handleDrop = result => {
    if (!result.destination || result.source.index === result.destination.index) return;
    const dropped = {
      id: result.draggableId,
      from: result.source.index,
      to: result.destination.index
    };
    onDrop && onDrop(dropped);
  };
  if (onDrop) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDrop,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Droppable, {
      droppableId: "drop-list",
      children: provided => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
        isDragList: true,
        ...defaultProps,
        ...provided.droppableProps,
        ref: provided.innerRef,
        children: [children, provided.placeholder]
      })
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
    ...defaultProps,
    children: children
  });
};
var _default = exports.default = BoxedTable;